/** @format */

import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, PLATFORM_ID, computed, inject } from '@angular/core';
import {
	ProductSocialContentState,
	SocialContentService,
	openSocialContentModal,
	selectProductSocialContentImages,
	setSocialContentCarouselIndex
} from '@social-content/data-access';

import { BreakPointNew } from '@shared/data-access/enums';
import { BreakpointsService } from '@shared/data-access/services';
import { HmfCarouselComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';

@Component({
	selector: 'pdp-social-content-images-carousel',
	imports: [CommonModule, HmfCarouselComponent],
	templateUrl: './images-carousel.component.html',
	styleUrl: './images-carousel.component.scss',
	standalone: true
})
export class ImagesCarouselComponent {
	socialContentService = inject(SocialContentService);
	platFormId = inject(PLATFORM_ID);
	breakPointsService = inject(BreakpointsService);

	store: Store<ProductSocialContentState> = inject(Store);
	readonly socialContentImages = this.store.selectSignal(selectProductSocialContentImages);

	isMobileSize = computed(() => this.breakPointsService.breakpoint() <= BreakPointNew.MEDIUM);

	shouldShowCarousel = computed(
		() => isPlatformBrowser(this.platFormId) && !!this.socialContentImages()?.length
	);

	openModal(index) {
		this.store.dispatch(openSocialContentModal());

		this.store.dispatch(setSocialContentCarouselIndex({ index: index }));
	}
}
